import { Icon } from '@design-system';
import { useTranslation } from 'next-i18next';

import { Image } from '../../../components/Image';
import { ProductPrice } from '../../../components/ProductPrice/ProductPrice';
import { ProductPurchaseDetails } from '../../../types/Purchasing';
import { renderArtistsNamesFromPageContent } from '../../../utils/artists';

type Props = {
  product: ProductType;
  productPrice: number;
  state: 'REFERENCE' | 'SENT';
  productPurchaseDetails: ProductPurchaseDetails;
  thumbnail: {
    filename: string;
    focus: string;
  };
};

export const EnquiryProduct: React.FC<Props> = ({
  product,
  productPrice,
  productPurchaseDetails,
  state,
  thumbnail,
}) => {
  const { t } = useTranslation('enquiries');

  const artistName = renderArtistsNamesFromPageContent(product.productArtist)
    ? renderArtistsNamesFromPageContent(product.productArtist)
    : productPurchaseDetails.artist;

  return (
    <div className="flex w-full items-stretch justify-between gap-x-3 rounded-sm border border-divider/20 p-4 md:p-4">
      <div className="h-12 w-12 flex-shrink-0 flex-grow-0">
        <Image
          alt={`${product.title} by ${artistName}`}
          eagerLoading
          focus={thumbnail.focus}
          src={thumbnail.filename}
          width={48}
        />
      </div>

      <div className="flex flex-grow flex-col justify-center">
        <div className="flex flex-row justify-between">
          <span className="line-clamp-1 font-bold">{artistName}</span>
          {state === 'REFERENCE' &&
            !productPurchaseDetails.enquireOnlyNoPrice && (
              <ProductPrice price={productPrice} />
            )}
        </div>
        <span className="max-w-2/3 line-clamp-1">{product.title}</span>
      </div>

      {state === 'SENT' && (
        <div className="flex items-center whitespace-nowrap text-positive-4">
          {t('drawers.successScreen.productSentNote')}&nbsp;
          <Icon name="ic_check" />
        </div>
      )}
    </div>
  );
};
